export default "__VITE_ASSET__2a62aac1__"